import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { FadeIn } from "@/components/common/FadeIn";

const metrics = [
  {
    value: "+30",
    label: "Años entregando soluciones",
    image: "/icons/icon-plus30-crop.png",
    imageAlt: "Ícono minimalista de trayectoria y crecimiento",
  },
  {
    value: "+50",
    label: "empresas cuenta con nuestro ERP",
    image: "/icons/icon-erp-crop.png",
    imageAlt: "Ícono minimalista de plataforma ERP empresarial",
  },
  {
    value: "+2.000",
    label: "usuarios operan nuestras soluciones",
    image: "/icons/icon-users-crop.png",
    imageAlt: "Ícono minimalista de usuarios operando soluciones",
  },
];

const heroSlides = [
  {
    topic: "Cosecha de Cerezas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/237fa17613bd721f99cb00028e8fe2c200937d8117c1e6a3b97f6d935b00f530.png",
    alt: "Cosecha de cerezas con trabajadores y canastos",
  },
  {
    topic: "Cosecha de Naranjas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/6053d07eb88f15f0de9aedb825ec5fbd3262e5f43ef4eda81bb7a84e362421f2.png",
    alt: "Cosecha de naranjas en huerto cítrico",
  },
  {
    topic: "Cosecha de Mandarinas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/5e835915a9be6af012f3be9c86cd454d251d3d16dacce25441ebb355bb1d81a0.png",
    alt: "Trabajadores recolectando mandarinas en plantación",
  },
  {
    topic: "Cosecha de Manzanas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/e5401632be9bcbe949eabf33b84a8f51dc378c7e19f8acefa1904d58a4b18b6d.png",
    alt: "Cosecha de manzanas en huerto frutal",
  },
  {
    topic: "Cosecha de Kiwis",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/09cf4307839d59bbc265f304de186337138c9f48dc0498c491439b8a5d8101a2.png",
    alt: "Cosecha de kiwis en plantación agrícola",
  },
  {
    topic: "Cosecha de Uvas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/6e266a3ba83880943d8b73157fd11e5b4ff3301fa98a5811e630b6e550151cdc.png",
    alt: "Vendimia y cosecha de uvas en viñedo",
  },
  {
    topic: "Salmones en Bins",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/1062f3423db274009ad4d97790acce36fe41cf637bd130bfe726147e9ee9e1e8.png",
    alt: "Salmones frescos en bins dentro de planta de proceso",
  },
  {
    topic: "Proceso de Embalaje de Salmones",
    image:
      "https://static.prod-images.emergentagent.com/jobs/ed9fba0f-d05c-45f9-a77a-3e8efa518b76/images/3fce885eab8344f3e070a8b256140933f4c6672c5df006889851954c04c70fe1.png",
    alt: "Línea de embalaje de salmones en proceso industrial",
  },
  {
    topic: "Tecnología de Información",
    image:
      "https://images.unsplash.com/photo-1768796372362-05c256e61d8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxpbmZvcm1hdGlvbiUyMHRlY2hub2xvZ3klMjBwcm9mZXNzaW9uYWxzJTIwZGF0YWNlbnRlcnxlbnwwfHx8fDE3NzMyMzMzNTR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Equipo de tecnología de información trabajando con infraestructura digital",
  },
  {
    topic: "Inteligencia Artificial",
    image:
      "https://images.unsplash.com/photo-1758626044744-463ce33546a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwYnVzaW5lc3MlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc3MzIzMzM1NXww&ixlib=rb-4.1.0&q=85",
    alt: "Escenario de inteligencia artificial aplicada a negocios",
  },
  {
    topic: "Carga de Contenedores en Barcos",
    image:
      "https://images.unsplash.com/photo-1602009775595-f35cf45d9f33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjb250YWluZXIlMjBzaGlwJTIwcG9ydCUyMGNyYW5lc3xlbnwwfHx8fDE3NzMyMzMzNzZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Puerto con carga de contenedores y barco logístico",
  },
];

export const Hero = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);
  const currentSlide = heroSlides[activeSlide];

  useEffect(() => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }

    intervalRef.current = window.setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length);
    }, 4000);

    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <section id="inicio" className="pb-16 pt-16 md:pb-24 md:pt-24" data-testid="hero-section">
      <div className="section-container grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
        <FadeIn className="md:col-span-7" delay={0.1}>
          <h1
            className="corporate-title-balance mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.06] text-[#595959]"
            data-testid="hero-main-heading"
          >
            Soluciones estratégicas para el siglo XXI
          </h1>
          <p className="mt-6 max-w-2xl text-sm md:text-base text-slate-600" data-testid="hero-description-text">
            Impulsamos a equipos directivos y operativos con una metodología clara y accionable para
            convertir desafíos complejos en crecimiento medible.
          </p>

          <div className="mt-8 flex flex-wrap gap-4" data-testid="hero-actions-wrapper">
            <Button
              asChild
              className="rounded-full bg-[#0077B6] px-6 text-xs uppercase tracking-[0.15em] text-white hover:bg-[#005F92]"
              data-testid="hero-primary-cta"
            >
              <a href="#soluciones" data-testid="hero-primary-cta-link">
                Soluciones <ArrowRight weight="bold" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-full border-[#B8C8D9] px-6 text-xs uppercase tracking-[0.15em] text-[#595959] hover:border-[#0077B6]"
              data-testid="hero-secondary-cta"
            >
              <a href="#contacto" data-testid="hero-secondary-cta-link">
                Ver contacto
              </a>
            </Button>
          </div>
        </FadeIn>

        <FadeIn className="md:col-span-5" delay={0.2}>
          <div className="image-frame relative aspect-[4/5]" data-testid="hero-image-frame">
            <AnimatePresence mode="wait">
              <motion.img
                key={currentSlide.topic}
                src={currentSlide.image}
                alt={currentSlide.alt}
                className="absolute inset-0 h-full w-full object-cover object-center"
                initial={{ opacity: 0, scale: 1.015, filter: "blur(2px)" }}
                animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                exit={{ opacity: 0, scale: 0.995, filter: "blur(2px)" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`hero-image-slide-${activeSlide + 1}`}
              />
            </AnimatePresence>
            <div
              className="absolute bottom-3 left-3 rounded-full bg-white/88 px-4 py-1.5 text-xs uppercase tracking-[0.12em] text-[#0077B6]"
              data-testid="hero-image-topic-chip"
            >
              {currentSlide.topic}
            </div>
          </div>
        </FadeIn>

        <FadeIn className="md:col-span-12" delay={0.35}>
          <div className="grid grid-cols-1 gap-4 border-t border-slate-200 pt-6 md:grid-cols-3" data-testid="hero-metrics-grid">
            {metrics.map((item) => (
              <article key={item.label} className="surface-glass p-5" data-testid={`hero-metric-${item.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                {item.image && (
                  <div className="mb-4 h-48 w-48 overflow-hidden rounded-md bg-white/90 p-1" data-testid="hero-metric-image-wrapper">
                    <img
                      src={item.image}
                      alt={item.imageAlt}
                      className="h-full w-full object-contain"
                      data-testid={`hero-metric-image-${item.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    />
                  </div>
                )}
                <p className="text-4xl font-semibold text-[#0077B6]" data-testid={`hero-metric-value-${item.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {item.value}
                </p>
                <p className="mt-2 text-base text-slate-600" data-testid={`hero-metric-label-${item.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {item.label}
                </p>
              </article>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
